import { render } from "./ServiceManagement.vue?vue&type=template&id=3073bf4c&scoped=true"
import script from "./ServiceManagement.vue?vue&type=script&lang=js"
export * from "./ServiceManagement.vue?vue&type=script&lang=js"

import "./ServiceManagement.vue?vue&type=style&index=0&id=3073bf4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3073bf4c"

export default script